import { http } from "@/communication";
import store from "@/store";

export default function logout(redirect) {
  store
    .dispatch("ping/stop")
    .then(() => http.post("/logout"))
    .finally(() => {
      window.location = redirect;
    });
}
